jQuery(document).ready(function($){

  console.log('jQuery');

  /* Slide details product */

    if ( $(".fosfo_custom_section").length ){


        var fosfoDetailsSlider = $(".fosfo_custom_section .slider");

        fosfoDetailsSlider.slick({

            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 400,
            autoplay: false,
            loop: true,
            accessibility: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode:true
                    }
                },
            ]
        });


        if ($(".fosfo_custom_section .rl").length && $(".fosfo_custom_section .slick-prev").length) {
            $(".fosfo_custom_section .rl").click(function () {
                $(".fosfo_custom_section .slick-prev").click();
            });
        }
        if ($(".fosfo_custom_section .rr").length && $(".fosfo_custom_section .slick-next").length) {
            $(".fosfo_custom_section .rr").click(function () {
                $(".fosfo_custom_section .slick-next").click();
            });
        }


        var $progressBarDetails = $('.fosfo_custom_section .progress');
        var iCompteur = parseInt($('.fosfo_custom_section .inner_slider').length);
        var percentProgress = 100 / iCompteur;
        $progressBarDetails.css('background-size', percentProgress+'% 100%').attr('aria-valuenow', percentProgress);

        fosfoDetailsSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var calc = (((nextSlide) / (slick.slideCount - 1)) * 100) + percentProgress;
            $progressBarDetails
                    .css('background-size', calc + '% 100%')
                    .attr('aria-valuenow', calc);
        });


    }

    /* Manuel Traduction */

    var attrLangHTML = $("html").attr('lang');

    if ( attrLangHTML == "en" ){

        if ( $("#custom_trad_excellet-rapport").length ){

            $("#custom_trad_excellet-rapport").text("Excellent report/price quality.");
          
        }

        if ( $("#custom_trad_confort_et_liberte").length ){

            $("#custom_trad_confort_et_liberte").text("Comfort and freedom.");
          
        }


        if ( $("#custom_trad_coupe").length ){

            $("#custom_trad_coupe").text("Fit.");
          
        }
      

        if ( $("#custom_trad_livraison").length ){

            $("#custom_trad_livraison").text("Free delivery.");
          
        }

        if ( $("#custom_trad_retour_facile").length ){

            $("#custom_trad_retour_facile").text("Easy return.");
          
        }

        if ( $("#custom_trad_qualit_garantie").length ){

            $("#custom_trad_qualit_garantie").text("Guaranteed quality.");
          
        }
      
    }

    /*------------------------*/
  
});